import React, { Component } from "react";
import ReportHeader from "../../../Report/ReportHeader";
import axios from "axios";
import Spinner from "../../../Common/Spinner";
import * as appConst from "../../../Common/constants";

class PatientList extends Component {
  constructor(props) {
    super(props);

    this.state = { patients: [], spinnerClass: "", dataClass: "collapse" };
  }

  componentDidMount() {
    axios
      .post(
        (process.env.NODE_ENV !== "development"
          ? appConst.API_URL_PROD
          : appConst.API_URL_DEV) +
        "/patient/listReport",
        this.props.data
      )
      .then(response => {
        this.setState({
          patients: response.data,
          spinnerClass: "collapse",
          dataClass: ""
        });
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  tabHeader() {
    let expData;
    if (this.props.data.type === "Expired")
      expData = <th className="border p-1 font-weight-bold">Exp Date</th>;
    else
      expData = (
        <th className="border p-1 font-weight-bold" width="300px">
          Address
        </th>
      );

    return (
      <tr>
        <th className="border p-1 font-weight-bold" width="100px">Patient#</th>
        <th className="border p-1 font-weight-bold" width="250px">Name</th>
        <th className="border p-1 font-weight-bold" width="200px">Phone</th>
      </tr>
    );
  }

  dateFormatter(params) {
    if (params.value !== null) {
      var arr = params.value.split("-");
      return arr[2].substring(0, 2) + "-" + arr[1] + "-" + arr[0];
    }
  }

  tabRow() {
    let reportType = this.props.data.type;
    return this.state.patients.map(function (obj) {
      return (
        <tr key={obj._id}>
          <td className="border p-1">{obj.pno}</td>
          <td className="border p-1 text-wrap">{obj.name}</td>
          <td className="border p-1">{obj.phone}</td>
        </tr>
      );
    });
  }

  DisplayFilter() {
    var arrFrom = new Date(this.props.data.fromDate)
      .toDateString()
      .split(" ");
    return (
      "( " +
      arrFrom[2] +
      "-" +
      arrFrom[1] +
      "-" +
      arrFrom[3] +
      " )"
    );
  }

  render() {
    return (
      <div>
        <ReportHeader onCloseClick={this.onCloseClick} IsClose="1" />
        <h3 align="center">Next OP Report</h3>
        <div align="center"> {this.DisplayFilter()}</div>
        <div className={this.state.spinnerClass}>
          <Spinner />
        </div>

        <div className={this.state.dataClass}>
          <div className="container-fluid reportFont">
            <table>
              <thead>{this.tabHeader()}</thead>
              <tbody>{this.tabRow()}</tbody>
            </table>
          </div>
        </div>
      </div>
    );
  }

  onCloseClick = e => {
    this.props.onCloseClick("Filter", null);
  };
}

export default PatientList;
